import { useSyncExternalStore } from 'react';

const listeners = new Set<() => void>();
type NavigationGuard = (proceed: () => void) => void;
let guard: NavigationGuard | null = null;
let currentIndex =
  typeof window === 'undefined'
    ? 0
    : Number(window.history.state?.portalIndex ?? 0);
let restoring = false;
let bypass = false;
if (typeof window !== 'undefined')
  window.history.replaceState(
    { ...window.history.state, portalIndex: currentIndex },
    '',
  );
const changed = () => {
  for (const listener of listeners) listener();
};

/** The editor owns the confirmation; the router retains the requested destination. */
export function blockNavigation(next: NavigationGuard) {
  guard = next;
  return () => {
    if (guard === next) guard = null;
  };
}
function go(path: string) {
  currentIndex += 1;
  window.history.pushState({ portalIndex: currentIndex }, '', path);
  changed();
}
export function navigate(path: string) {
  if (guard) guard(() => go(path));
  else go(path);
}
if (typeof window !== 'undefined')
  window.addEventListener('popstate', () => {
    if (restoring) {
      restoring = false;
      return;
    }
    const nextIndex = Number(
      window.history.state?.portalIndex ?? currentIndex - 1,
    );
    const delta = nextIndex - currentIndex;
    if (guard && !bypass && delta) {
      restoring = true;
      window.history.go(-delta);
      guard(() => {
        bypass = true;
        window.history.go(delta);
      });
      return;
    }
    bypass = false;
    currentIndex = nextIndex;
    changed();
  });
export function usePath(): string {
  return useSyncExternalStore(
    (onChange) => {
      listeners.add(onChange);
      return () => {
        listeners.delete(onChange);
      };
    },
    () => window.location.pathname,
  );
}
